import request from '@/utils/request'

// 获取商户列表
export const getOutList = function (data) {
    return request({
        url: '/api/order/getOutList',
        method: 'post',
        data: data
    })
}


// 获取订单详情
export const getOutInfo = function (data) {
    return request({
        url: '/api/order/getOutInfo',
        method: 'post',
        data: data
    })
}

export const getQrcode = function (data) {
    return request({
        url: '/api/shop/qrcode',
        method: 'get',
        params: data
    })
}

export const getMincode = function (data) {
    return request({
        url: '/api/shop/mincode',
        method: 'get',
        params: data
    })
}

export const getPreaddorder = function (data) {
    return request({
        url: '/api/express/preaddorder',
        method: 'get',
        params: data
    })
}

export const getAddOrder = function (data) {
    return request({
        url: '/api/express/addOrder',
        method: 'get',
        params: data
    })
}

export const getQueryOrder = function (data) {
    return request({
        url: '/api/express/queryOrder',
        method: 'get',
        params: data
    })
}

export const getCancelOrder = function (data) {
    return request({
        url: '/api/express/cancelOrder',
        method: 'get',
        params: data
    })
}

export default {
    getOutList,
    getOutInfo,
    getQrcode,
    getMincode,

    getPreaddorder,
    getAddOrder,
    getQueryOrder,
    getCancelOrder,
}
